import { ArrowUpRight } from "lucide-react";
import { FadeUp, ClipReveal } from "./Reveal";
import { SERVICES, IMAGES } from "../../lib/site";

export default function Services() {
  return (
    <section id="services" className="relative py-24 lg:py-32" data-testid="services-section">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <FadeUp className="mb-20 max-w-2xl">
          <span className="font-body text-xs tracking-[0.35em] text-[#00D166]">WHAT WE DO</span>
          <h2 className="mt-4 font-display text-4xl md:text-6xl font-bold tracking-tight text-white">
            Two disciplines. <span className="font-serifed italic font-normal text-white/60">One standard.</span>
          </h2>
        </FadeUp>

        <div className="space-y-px bg-white/10 border border-white/10">
          {SERVICES.map((s, idx) => (
            <div key={s.no} className="bg-[#030712] grid lg:grid-cols-12 gap-8 p-8 lg:p-14 group">
              <div className="lg:col-span-1">
                <span className="font-serifed italic text-6xl md:text-7xl text-white/10 group-hover:text-[#00D166]/40 transition-colors duration-500">
                  {s.no}
                </span>
              </div>

              <div className="lg:col-span-6">
                <FadeUp>
                  <p className="font-serifed italic text-[#00D166] text-2xl mb-3">{s.tagline}</p>
                  <h3 className="font-display text-3xl md:text-5xl font-bold tracking-tight text-white mb-6">{s.title}</h3>
                  <p className="font-body text-white/60 leading-relaxed max-w-lg mb-8">{s.desc}</p>
                  <div className="flex flex-wrap gap-x-8 gap-y-3">
                    {s.points.map((p) => (
                      <span key={p} className="flex items-center gap-2 font-body text-sm text-white/80">
                        <span className="h-1.5 w-1.5 bg-[#00D166]" /> {p}
                      </span>
                    ))}
                  </div>
                  <a
                    href="#contact"
                    data-testid={`service-cta-${s.no}`}
                    className="mt-8 inline-flex items-center gap-2 font-body text-sm font-semibold text-white group-hover:text-[#00D166] transition-colors"
                  >
                    Enquire <ArrowUpRight size={16} />
                  </a>
                </FadeUp>
              </div>

              <div className="lg:col-span-5">
                <ClipReveal className="aspect-[4/3] lg:aspect-auto lg:h-full overflow-hidden border border-white/10">
                  <img
                    src={idx === 0 ? IMAGES.office : IMAGES.skyline}
                    alt={s.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </ClipReveal>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
